<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-28 19:03:57
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Punch\AbnormalClockin\AbnormalClockin.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-07 14:55:58
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_admin_abnormalClockin_list_title')"
    @activated="activated"
    pad="0"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Taber
        contentBackground="transparent"
        :curTab="curTab"
        special
        @change="(tab) => (curTab = tab)"
        :items="taber"
        @filter="
          (val, tab) => {
            if (tab == 0) {
              filterPageData0 = val;
            } else if (tab == 1) filterPageData1 = val;
            else filterPageData2 = val;
          }
        "
      >
        <!-- 筛选 -->
        <template v-slot:filter-content-1="{ filter }">
          <div v-show="curTab === 'tab-1'">
            <Selections2
              :objects="filterObjects"
              small-chip
              @filter="
                filter();
                toFilter(0, filter);
              "
              @update="
                (prop, value, selected) => {
                  $fliterValue(filterObjects, prop, value, selected);
                }
              "
              @reset="
                (apply) => {
                  $fliterValue(filterObjects, null, null);
                  if (apply) {
                    filter();
                    toFilter(0, filter);
                  }
                }
              "
            />
          </div>
        </template>
        <template v-slot:filter-content-2="{ filter }">
          <div v-show="curTab === 'tab-2'">
            <Selections2
              :objects="filterObjects1"
              small-chip
              @filter="
                filter();
                toFilter(1, filter);
              "
              @update="
                (prop, value, selected) => {
                  $fliterValue(filterObjects1, prop, value, selected);
                }
              "
              @reset="
                (apply) => {
                  $fliterValue(filterObjects1, null, null);
                  if (apply) {
                    filter();
                    toFilter(1, filter);
                  }
                }
              "
            />
          </div>
        </template>
        <template v-slot:filter-content-3="{ filter }">
          <div v-show="curTab === 'tab-3'">
            <Selections2
              :objects="filterObjects2"
              small-chip
              @filter="
                filter();
                toFilter(2, filter);
              "
              @update="
                (prop, value, selected) => {
                  $fliterValue(filterObjects2, prop, value, selected);
                }
              "
              @reset="
                (apply) => {
                  $fliterValue(filterObjects2, null, null);
                  if (apply) {
                    filter();
                    toFilter(2, filter);
                  }
                }
              "
            />
          </div>
        </template>
        <template v-slot:content-1>
          <Tabler
            :headers="headers"
            :filter-page-data="filterPageData0"
            :items="desserts0"
            :showSelect="showSelect"
            :height="$vuetify.breakpoint.height - 335"
            :totalCount="totalCount0"
            @change="
              (page, perpage, callback, data) => {
                getList(0, data, page, perpage, callback);
              }
            "
          >
            <template v-slot:item.applicant="{ item }">
              <div style="max-width: 300px">
                <v-list-item dense two-line class="pa-0">
                  <v-list-item-avatar size="36" class="mr-1 my-0">
                    <StaffAvatar
                      size="36"
                      :src="item.agent_staff.staff_avatar"
                      :staff_name="item.agent_staff.preferred_name"
                    />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="table-title text--primary">
                      {{ $getCommonLangValue(item.agent_staff.preferred_name) }}
                      <span class="text--secondary text-caption-xs">
                        {{ item.agent_staff.staff_code }}</span
                      >
                    </v-list-item-title>
                    <v-list-item-subtitle
                      class="table-subtitle text--secondary"
                    >
                      {{ $getCommonLangValue(item.agent_staff.job_post_name) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </template>
            <template v-slot:item.date="{ item }">
              {{ $getDateTime(item.submission_utc_datetime, "YYYY/MM/DD") }}
            </template>
            <!-- // 改为显示实际打卡时间 buglist1476 mel -->

            <!-- <template v-slot:item.shift="{ item }">
              {{ $getCommonLangValue(item.shift_name) }}
            </template> -->
            <template v-slot:item.actual="{ item }">
              {{ $getDateTime(item.punch_utc_datetime, "HH:mm") }}
            </template>
            <template v-slot:item.swift_number="{ item }">
              {{ item.swift_number }}
            </template>
            <template v-slot:item.status="{ item }">
              <StatusChip
                :slideColor="item.approval_tint_color"
                :bgColor="item.approval_bg_color"
              >
                <template v-slot:status>
                  {{ $getCommonLangValue(item.status_detail) }}
                </template>
              </StatusChip>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                @click="toEdit(item.uuid)"
                v-if="hasBtn('view-admin-abnormal-clock-in')"
              >
                <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
              </v-btn>
            </template>
          </Tabler>
        </template>
        <template v-slot:content-2>
          <Tabler
            :headers="headers"
            :items="desserts1"
            :showSelect="showSelect"
            :height="$vuetify.breakpoint.height - 335"
            :filter-page-data="filterPageData1"
            :totalCount="totalCount1"
            @change="
              (page, perpage, callback, data) => {
                getList(1, data, page, perpage, callback);
              }
            "
          >
            <template v-slot:item.swift_number="{ item }">
              {{ item.swift_number }}
            </template>
            <template v-slot:item.applicant="{ item }">
              <div style="max-width: 300px">
                <v-list-item dense two-line class="pa-0">
                  <v-list-item-avatar size="36" class="mr-1 my-0">
                    <StaffAvatar
                      size="36"
                      :src="item.agent_staff.staff_avatar"
                      :staff_name="item.agent_staff.preferred_name"
                    />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="table-title text--primary">
                      {{ $getCommonLangValue(item.agent_staff.preferred_name) }}
                      <span class="text--secondary text-caption-xs">
                        {{ item.agent_staff.staff_code }}</span
                      >
                    </v-list-item-title>
                    <v-list-item-subtitle
                      class="table-subtitle text--secondary"
                    >
                      {{ $getCommonLangValue(item.agent_staff.job_post_name) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </template>
            <template v-slot:item.date="{ item }">
              {{ $getDateTime(item.submission_utc_datetime, "YYYY/MM/DD") }}
            </template>
            <!-- // 改为显示实际打卡时间 buglist1476 mel -->

            <!-- <template v-slot:item.shift="{ item }">
              {{ $getCommonLangValue(item.shift_name) }}
            </template> -->
            <template v-slot:item.actual="{ item }">
              {{ $getDateTime(item.punch_utc_datetime, "HH:mm") }}
            </template>
            <template v-slot:item.status="{ item }">
              <StatusChip
                :slideColor="item.approval_tint_color"
                :bgColor="item.approval_bg_color"
              >
                <template v-slot:status>
                  {{ $getCommonLangValue(item.status_detail) }}
                </template>
              </StatusChip>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                @click="toEdit(item.uuid)"
                v-if="hasBtn('view-admin-abnormal-clock-in')"
              >
                <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
              </v-btn>
            </template>
          </Tabler>
        </template>
        <template v-slot:content-3>
          <Tabler
            :headers="headers"
            :items="desserts2"
            :showSelect="showSelect"
            :height="$vuetify.breakpoint.height - 335"
            :filter-page-data="filterPageData2"
            :totalCount="totalCount2"
            @change="
              (page, perpage, callback, data) => {
                getList(2, data, page, perpage, callback);
              }
            "
          >
            <template v-slot:item.swift_number="{ item }">
              {{ item.swift_number }}
            </template>
            <template v-slot:item.applicant="{ item }">
              <div style="max-width: 300px">
                <v-list-item dense two-line class="pa-0">
                  <v-list-item-avatar size="36" class="mr-1 my-0">
                    <StaffAvatar
                      size="36"
                      :src="item.agent_staff.staff_avatar"
                      :staff_name="item.agent_staff.preferred_name"
                    />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="table-title text--primary">
                      {{ $getCommonLangValue(item.agent_staff.preferred_name) }}
                      <span class="text--secondary text-caption-xs">
                        {{ item.agent_staff.staff_code }}</span
                      >
                    </v-list-item-title>
                    <v-list-item-subtitle
                      class="table-subtitle text--secondary"
                    >
                      {{ $getCommonLangValue(item.agent_staff.job_post_name) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </template>
            <template v-slot:item.date="{ item }">
              {{ $getDateTime(item.submission_utc_datetime, "YYYY/MM/DD") }}
            </template>
            <!-- // 改为显示实际打卡时间 buglist1476 mel -->

            <!-- <template v-slot:item.shift="{ item }">
              {{ $getCommonLangValue(item.shift_name) }}
            </template> -->
            <template v-slot:item.actual="{ item }">
              {{ $getDateTime(item.punch_utc_datetime, "HH:mm") }}
            </template>
            <template v-slot:item.status="{ item }">
              <StatusChip
                :slideColor="item.approval_tint_color"
                :bgColor="item.approval_bg_color"
              >
                <template v-slot:status>
                  {{ $getCommonLangValue(item.status_detail) }}
                </template>
              </StatusChip>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                @click="toEdit(item.uuid)"
                v-if="hasBtn('view-admin-abnormal-clock-in')"
              >
                <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
              </v-btn>
            </template>
          </Tabler>
        </template>
      </Taber>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "AbnormalClockin",
  computed: {},
  data() {
    return {
      headers: [
        {
          text: "label_essweb_abnormalClockin_form_swiftNumberLabel",
          value: "swift_number",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_abnormalClockin_list_applicantLabel",
          value: "applicant",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_abnormalClockin_list_dateLabel",
          value: "date",
          align: "start",
          sortable: false,
        },
        // 改为显示实际打卡时间 buglist1476 mel
        // {
        //   text: "label_essweb_abnormalClockin_list_shiftLabel",
        //   value: "shift",
        //   align: "start",
        //   sortable: false,
        // },
        {
          text: "label_essweb_punchRecord_list_timeLabel",
          value: "actual",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_abnormalClockin_list_statusLabel",
          value: "status",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts0: [],
      desserts1: [],
      desserts2: [],
      totalCount0: 0,
      totalCount1: 0,
      totalCount2: 0,
      showSelect: false,
      showDelete: false,
      search: "",
      curTab: "tab-1",
      taber: [
        "label_essweb_abnormalClockin_list_tag_draftLabel",
        "label_essweb_abnormalClockin_list_tag_underReviewLabel",
        "label_essweb_abnormalClockin_list_tag_completeLabel",
      ],
      filterPageData0: null,
      filterPageData1: null,
      filterPageData2: null,
      filterObjects: [
        {
          type: "string",
          sequence: 0,
          name: "swift_number",
          position: "right",
          label: "label_essweb_abnormalClockin_form_swiftNumberLabel",

          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          showKey: "preferred_name",
          subKey: "job_post_name",
          avatar: true,
          twoLine: true,
          name: "staff",
          multiple: true,
          label: "label_essweb_abnormalClockin_list_applicantLabel",
          value: [],

          selected: [],
          data: {
            api: "all_staff",
            url_type: "all_staff",
            args: null,
            table: "mrbase_sys_staffs",
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "daterange",
          sequence: 2,
          name: "date",
          position: "right",
          label: "label_essweb_abnormalClockin_list_dateLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 3,
          position: "right",
          statusChip: "approval",
          name: "status",
          multiple: true,
          label: "label_essweb_abnormalClockin_list_statusLabel",
          value: [],

          selected: [],
          data: {
            api: "ess_approval_status_detail_select",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },
      ],
      filterObjects1: [
        {
          type: "string",
          sequence: 0,
          name: "swift_number",
          position: "right",
          label: "label_essweb_abnormalClockin_form_swiftNumberLabel",

          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          showKey: "preferred_name",
          subKey: "job_post_name",
          avatar: true,
          twoLine: true,
          name: "staff",
          multiple: true,
          label: "label_essweb_abnormalClockin_list_applicantLabel",
          value: [],

          selected: [],
          data: {
            api: "all_staff",
            url_type: "all_staff",
            args: null,
            table: "mrbase_sys_staffs",
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "daterange",
          sequence: 2,
          name: "date",
          position: "right",
          label: "label_essweb_abnormalClockin_list_dateLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 3,
          position: "right",
          statusChip: "approval",
          name: "status",
          multiple: true,
          label: "label_essweb_abnormalClockin_list_statusLabel",
          value: [],

          selected: [],
          data: {
            api: "ess_approval_status_detail_select",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },
      ],
      filterObjects2: [
        {
          type: "string",
          sequence: 0,
          name: "swift_number",
          position: "right",
          label: "label_essweb_abnormalClockin_form_swiftNumberLabel",

          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          showKey: "preferred_name",
          subKey: "job_post_name",
          avatar: true,
          twoLine: true,
          name: "staff",
          multiple: true,
          label: "label_essweb_abnormalClockin_list_applicantLabel",
          value: [],

          selected: [],
          data: {
            api: "all_staff",
            url_type: "all_staff",
            args: null,
            table: "mrbase_sys_staffs",
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          showKey: "dict_label",
          name: "staff_status",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobStatusLabel",
          value: [],
          selected: [],
          data: {
            api: "/dictionary/list-dictionary-byname/",
            url_type: "primary",
            args: { dict_name: "staffStatus" },
            table: "mrbase_sys_dict",
            type: "lang",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
        {
          type: "daterange",
          sequence: 2,
          name: "date",
          position: "right",
          label: "label_essweb_abnormalClockin_list_dateLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 3,
          position: "right",
          statusChip: "approval",
          name: "status",
          multiple: true,
          label: "label_essweb_abnormalClockin_list_statusLabel",
          value: [],

          selected: [],
          data: {
            api: "ess_approval_status_detail_select",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },
      ],
      first: false,
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(0, null, 1, this.$tableSetting.perPageSize, null);
    this.getList(1, null, 1, this.$tableSetting.perPageSize, null);
    this.getList(2, null, 1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    toDelete: function () {},
    toEdit: function (uuid) {
      this.$toPage(
        "/admin/abnormal-clock-in/detail/" +
          this.$aesEncrypt(
            JSON.stringify({
              id: uuid,
            })
          )
      );
    },
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.$fliterValue(this.filterObjects, null, null);
        this.$fliterValue(this.filterObjects1, null, null);
        this.$fliterValue(this.filterObjects2, null, null);
        this.desserts0 = [];
        this.desserts1 = [];
        this.desserts2 = [];
        this.curTab = "tab-1";
        this.getList(0, null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        this.getList(1, null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        this.getList(2, null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        this.first = true;
      }
      if (refresh == 1) {
        this.curTab = "tab-1";
        if (this.filterPageData1 || this.filterPageData2) {
          let page1 = 1,
            page2 = 1,
            page0 = 1,
            pagesize1 = null,
            pagesize2 = null,
            pagesize0 = null;
          if (this.filterPageData1 && this.filterPageData1["data"]) {
            page1 = this.filterPageData1["data"]["cpage"]
              ? this.filterPageData1["data"]["cpage"]
              : 1;
            pagesize1 = this.filterPageData1["data"]["pagesize"]
              ? this.filterPageData1["data"]["pagesize"]
              : null;
          }
          if (this.filterPageData2 && this.filterPageData2["data"]) {
            page2 = this.filterPageData2["data"]["cpage"]
              ? this.filterPageData2["data"]["cpage"]
              : 1;
            pagesize2 = this.filterPageData2["data"]["pagesize"]
              ? this.filterPageData2["data"]["pagesize"]
              : null;
          }
          if (this.filterPageData0 && this.filterPageData0["data"]) {
            page0 = this.filterPageData0["data"]["cpage"]
              ? this.filterPageData0["data"]["cpage"]
              : 1;
            pagesize0 = this.filterPageData0["data"]["pagesize"]
              ? this.filterPageData0["data"]["pagesize"]
              : null;
          }
          this.toFilter(0, () => {}, page0, pagesize0);
          this.toFilter(1, () => {}, page1, pagesize1);
          this.toFilter(2, () => {}, page2, pagesize2);
        } else {
          this.toFilter(0, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
          this.toFilter(2, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    toFilter(tab, callback, page, pagesize) {
      const that = this;
      let object = [];
      if (tab == 0) {
        object = this.filterObjects.filter((ele) =>
          Object.prototype.toString.call(ele["value"]).toLowerCase() ===
          "[object array]"
            ? ele["value"].length
            : ele.value !== undefined && ele.value != ""
        );
      } else if (tab == 1) {
        object = this.filterObjects1.filter((ele) =>
          Object.prototype.toString.call(ele["value"]).toLowerCase() ===
          "[object array]"
            ? ele["value"].length
            : ele.value !== undefined && ele.value != ""
        );
      } else {
        object = this.filterObjects2.filter((ele) =>
          Object.prototype.toString.call(ele["value"]).toLowerCase() ===
          "[object array]"
            ? ele["value"].length
            : ele.value !== undefined && ele.value != ""
        );
      }

      let data = {
        approval_status: tab,
      };
      object.map((item) => {
        if (item["name"] == "staff")
          data["applicant_staff_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "approver")
          data["staff_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "date") {
          data["start_date"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[0] : ""
          );
          data["end_date"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[1] : ""
          );
        }
        if (item["name"] == "swift_number") {
          data["application_swift_number"] = item.value;
        }
        if (item["name"] == "status") {
          data["status_detail"] = item.value.join(",");
        }
        if (item["name"] == "staff_status")
          data["staff_status"] = item.value ? item.value.join(",") : "";
      });
      if (!page) {
        this.getList(tab, data, 1, this.$tableSetting.perPageSize, callback);
      } else {
        this.getList(
          tab,
          data,
          page ? page : 1,
          pagesize ? pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    getList: function (status, data, page, perpage, callback) {
      const that = this;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_punch_invalid_record_application",
        url: "/punch_invalid_record_application/get-punch_invalid_record_application-list/",
        data: data
          ? data
          : {
              approval_status: status,
              cpage: page,
              pagesize: perpage,
            },
      })
        .then((res) => {
          if (status == 0) {
            that.desserts0 = res.data;
            that.totalCount0 = res.totalcount;
          }
          if (status == 1) {
            that.desserts1 = res.data;
            that.totalCount1 = res.totalcount;
          }
          if (status == 2) {
            that.desserts2 = res.data;
            that.totalCount2 = res.totalcount;
          }
          callback ? callback(page, perpage, data, status) : null;
        })
        .catch(() => {
          callback ? callback(page, perpage, data, status) : null;
        });
    },
  },
};
</script>
